import { useQuery } from 'react-query';

import { axiosInstance } from '@/axios';
import { QUERY_KEY } from '@/components/UserTags/common';
import type { FacetType } from '@/types';

export const useTagsFilter = (options?: UseTagsFilterType) => {
  const { channelId } = options || {};

  return useQuery(
    [QUERY_KEY, 'filters', channelId],
    ({ signal }) =>
      axiosInstance.post<FacetType>(
        '/search/tags',
        {
          type: 'filter',
          num_docs: 0,
          filter: {},
          sort: [{ sort: 'timestamp', order: 'desc' }],
          ...(channelId && { channel_id: channelId }),
        },
        {
          signal,
        }
      ),
    { staleTime: Infinity, select: (data) => data.data.facets['tags'] }
  );
};

type UseTagsFilterType = {
  channelId?: string;
};
